import { Injectable } from '@angular/core';
import { PermissionTypes, PFWmsEntities } from '@pf/shared-common';
import { AbstractRouteBuilder } from '@pf/shared-services';
import { buildWmsPermissionPath } from '@pf/shared/util-platform';

@Injectable()
export class RoutesForWarehouse extends AbstractRouteBuilder {
    permissionType = buildWmsPermissionPath(
        PermissionTypes.Modify,
        PFWmsEntities.Warehouse
    );

    structure(id: string) {
        return this.urlFromCommands([id, 'structure']);
    }
}
